import { Injectable, inject } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpInterceptorFn } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from '../service/auth.service';
import { environment } from '@env/environment';
import { AppConfigData } from 'app/app.config.data';

// @Injectable()
// export class JwtInterceptor implements HttpInterceptor {
//   constructor(private authenticationService: AuthService) {}

//   intercept(
//     request: HttpRequest<any>,
//     next: HttpHandler
//   ): Observable<HttpEvent<any>> {
//     // add authorization header with jwt token if available
//     if (request.url.startsWith(environment.imageBaseUrl)) { // For Image base URL services.
//       let imageToken: string = localStorage.getItem('imageToken');
//       if (imageToken) {
//         request = request.clone({
//           setHeaders: {
//             Authorization: `Bearer ${imageToken}`,
//           }
//         });
//       }
//     } else if (request.url.startsWith(environment.aiBaseURL)) { // For Image base URL services.
//       let aiToken: string = localStorage.getItem('aiToken');
//       if (aiToken) {
//         request = request.clone({
//           setHeaders: {
//             Authorization: `Bearer ${aiToken}`,
//           }
//         });
//       }
//     }else { // For falcon api services.
//       let currentUser = this.authenticationService.currentUserValue;
//       if (currentUser && currentUser.token) {
//         request = request.clone({
//           setHeaders: {
//             Authorization: `Bearer ${currentUser.token}`,
//           },
//         });
//       }
//     }

//     return next.handle(request);
//   }
// }

export const jwtInterceptor: HttpInterceptorFn = (req, next) => {

  const authService = inject(AuthService);

  // add authorization header with jwt token if available
  if (req.url.startsWith(AppConfigData.imageBaseUrl)) { // For Image base URL services.
    let imageToken: string = localStorage.getItem('imageToken');
    if (imageToken) {
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${imageToken}`,
        }
      });
    }
  } else if (req.url.startsWith(environment.aiBaseURL)||req.url.startsWith(AppConfigData.cliNoteUrl)) { // For Image base URL services.
    let aiToken: string = localStorage.getItem('aiToken');
    if (aiToken) {
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${aiToken}`,
        }
      });
    }
  }else if (req.url.startsWith(environment.openAI)) { // For open AIe URL services.
    let aiToken: string = authService.decrypt(environment.aiToken);
    if (aiToken) {
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${aiToken}`,
        }
      });
    }
  } else if (req.url.startsWith(environment.fhirServer)) { // For FHIR server services.
    req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${environment.fhirToken}`,
        },
      });
  }
  // else if (req.url.startsWith(AppConfigData.cliNoteUrl)) { // For FHIR server services.
  //   req = req;
  // }
  else { // For falcon api services.
    let currentUser = authService.currentUserValue;
    if (currentUser && currentUser.token) {
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${currentUser.token}`,
        },
      });
    }
  }

  return next(req);
};